import useApp from "@/hooks/useApp";
import Modal from "@/components/Modal";

export default function InquiryModal() {
  const app = useApp();

  if (!app.state.shownInquiryModal) return <></>;

  return (
    <Modal onClickDimd={app.setShownInquiryModal.bind(null, false)}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "30px 200px 30px 200px",
          background: "#fff",
        }}
      >
        <p>is inquiry modal</p>
        <button style={{ marginTop: 30 }} onClick={app.setShownInquiryModal.bind(null, false)}>
          close
        </button>
      </div>
    </Modal>
  );
}
